<template src='./create-system-user.html'></template>

<script>
// import securityStore from '@/store/security-store.js'
import Vue from 'vue'
import ContextPage from '@/components/context-page/ContextPage'
import { EventBus } from '@/router/bus'

export default {
  components: {
    ContextPage
  },
  data () {
    return {
      user: {
        Login: '',
        // LoginAd: '',
        Name: '',
        RoleId: '',
        GroupId: ''
      },
      roles: [],
      groups: [],
      dialog: false,
      formValid: true,
      loading: false,
      nameRules: [
        v => !!v || this.$t('validation.nameRequired')
      ],
      emailRules: [
        v => !!v || this.$t('validation.emailRequired'),
        v => /.+@.+\..+/.test(v) || this.$t('validation.emailRequired')
      ],
      roleRules: [
        v => !!v || this.$t('validation.roleRequired')
      ],
      alertShow: false,
      alertType: 'error',
      alertText: ''
    }
  },
  methods: {
    addUser () {
      this.loading = true
      this.dialog = false
      this.$http.post(Vue.$apiConfig.createSystemUserPost, [this.user]).then(
        response => {
          this.loading = false
          for (let i = 0; i < response.data.payload.length; i++) {
            if (response.data.payload[i].error !== null) {
              this.alertShow = true
              EventBus.$emit('alert', {
                variant: 'error',
                message: this.$t('apiStatusCodes.' + response.data.payload[i].error.code)
              })
            } else {
              EventBus.$emit('alert', {
                variant: 'success',
                message: this.$t('administration.createUserSuccessful')
              })
              this.$refs.form.reset()
            }
          }
        },
        error => {
          this.formatErrorResponse(error)
          this.logConsole(error)
          this.loading = false
        })
    },
    openDialog () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.dialog = true
    }
  },
  created () {
    this.loading = true
    // add api get request to roles and groups, localRoles and groups are muck for now
    this.$http.get(Vue.$apiConfig.getAllUserRoles).then(
      response => {
        response.data.payload.forEach((role) => {
          this.roles.push({ text: this.$t('roles.' + role.name), value: role.id })
        })
        this.loading = false
      },
      error => {
        this.formatErrorResponse(error)
        this.logConsole(error)
        this.roles.push({ text: this.$t('general.noDataAvailable'), value: 0 })
        this.loading = false
      }
    )
  }
}
</script>

<style scoped>
  .v-label {
    font-size: 15px !important;
  }
  .v-input__slot {
    margin-bottom: 0px !important;
  }
  .v-card__text {
    font-size: 20px;
  }
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
